import React, { useState } from 'react';

// FAQ Component - Frequently Asked Questions section
const FAQ = () => {
  // State to track which FAQ item is expanded
  const [openIndex, setOpenIndex] = useState(null);

  // FAQ data - questions and answers
  const faqData = [
    {
      question: 'How does the AI photoshoot generation work?',
      answer: 'Simply upload your raw jewelry image, choose your preferred style (AI model, real human, or aesthetic background), and our AI will generate a professional photoshoot in under 30 seconds.'
    },
    {
      question: 'What image formats do you support?',
      answer: 'We support JPG, PNG, and WEBP formats. For best results, upload high-resolution images with good lighting and clear jewelry visibility.'
    },
    {
      question: 'How many credits do I get for free?',
      answer: 'New users receive 10 free credits (worth ₹250) upon signing up. This allows you to generate 5 professional images to test our service.'
    },
    {
      question: 'Can I download the generated images?',
      answer: 'Yes! All generated images are available for immediate download in high resolution. You own the rights to use these images for your business.'
    },
    {
      question: 'Do credits expire?',
      answer: 'No, credits never expire.'
    }
  ];

  // Toggle FAQ item expansion
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        <h2 className="faq-title">Frequently Asked Questions</h2>
        <div className="faq-list">
          {faqData.map((faq, index) => (
            <div key={index} className={`faq-item ${openIndex === index ? 'open' : ''}`}>
              <button 
                className="faq-question" 
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span className="faq-question-text">{faq.question}</span>
                <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
              </button>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;

